module.exports = __webpack_public_path__ + "img/logo-icon.4b61af49.png";